import React from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {toggleHideItemsSwitcher} from "../../actions/actionFunctions";
import Analytics from "../../analytics";
import {getShowPrice} from "../../misc/priceFunctions";

const HideItemsSwitcher = (props) => {

  const {fabricatorData, toggleHideItemsSwitcher, productionSheetCheckbox} = props;

  const allowedForEmployee = Array.isArray(document.dashboardUserPermissions)
    && document.dashboardUserPermissions.some(permission => {
      return permission.ProtectedAreaId === 9003 && permission.AccessRights !== 0
    }); // Show Checkout Line Item Prices Toggle

  if (!document.kvConfig.isBackend || (!fabricatorData.showCheckoutLineItemPricesToggle && !allowedForEmployee)) {
    return null
  }

  const showPrices = getShowPrice(fabricatorData);

  const handleButtonClick = () => {
    Analytics.sendClickEvent(`toggle-show-prices-${!showPrices ? "on" : "off"}`);
    toggleHideItemsSwitcher();
  };

  const disabled = productionSheetCheckbox;

  return (
    <div className="ui-radio-block">
      <span className="ui-radio-label"><FormattedMessage id="header.togglePricesCheckbox"/></span>
      <button className={"ui-radio ui-radio--small" + (showPrices ? " ui-radio--checked" : "")}
              title={disabled ? "Can't disable as Production Sheet is on" : ""}
              onClick={disabled ? null : handleButtonClick}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  const {productionSheetCheckbox} = store.serverState;
  return {
    fabricatorData,
    productionSheetCheckbox,
  };
};

const mapDispatchToProps = {
  toggleHideItemsSwitcher,
};

export default connect(mapStateToProps, mapDispatchToProps)(HideItemsSwitcher);
